/**
 * WallSnobs murals — wall size, printed area, and the per-substrate estimate.
 *
 * Everything here is arithmetic on numbers the server already put in the DOM.
 * Rates come from `data-rate-cents` on each row, which Liquid derived from the
 * variant price — so this file never invents a price, and when the visitor is
 * not an approved trade account there are no rate rows to read and the money
 * half of the panel simply does not exist.
 *
 * Money is formatted by taking the prefix and suffix off a figure Liquid
 * already rendered. Reimplementing the shop's currency format in JS goes
 * subtly wrong for anyone not on plain dollars.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-ws-mural]');
    if (!root) return;

    var wFt = root.querySelector('[data-ws-w-ft]');
    var wIn = root.querySelector('[data-ws-w-in]');
    var hFt = root.querySelector('[data-ws-h-ft]');
    var hIn = root.querySelector('[data-ws-h-in]');
    if (!wFt || !hFt) return;

    var wallOut = root.querySelector('[data-ws-wall-area]');
    var printOut = root.querySelector('[data-ws-print-area]');
    var rateRows = [].slice.call(root.querySelectorAll('[data-ws-rate]'));
    var trim = parseFloat(root.dataset.trim) || 0;

    /* Lift the currency format off a rendered rate. Absent when logged out,
       which is fine — there is nothing to format in that state. */
    var PREFIX = '', SUFFIX = '';
    (function () {
      var sample = root.querySelector('.ws-mural__rate-unit');
      if (!sample) return;
      var m = sample.textContent.trim().match(/^(\D*)[\d.,]+(\D*?)\s*\/\s*sq\s*ft$/i);
      if (m) { PREFIX = m[1]; SUFFIX = m[2]; }
    })();

    function money(cents) {
      var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return PREFIX + n + SUFFIX;
    }

    var num = function (el) {
      if (!el) return 0;
      var v = parseFloat(el.value);
      return isNaN(v) || v < 0 ? 0 : v;
    };

    /* Round up to a sensible printing increment rather than showing a wall
       area to four decimal places. One decimal is what an installer reads. */
    var round1 = function (n) { return Math.round(n * 10) / 10; };

    function render() {
      var wInches = num(wFt) * 12 + num(wIn);
      var hInches = num(hFt) * 12 + num(hIn);

      var wallSqft = (wInches * hInches) / 144;

      /* Trim is added to every edge, so each dimension grows by twice the
         allowance — a 4 in allowance on a 120 in wall prints 128 in. Adding it
         once is the easy mistake and it under-orders every job. */
      var printW = wInches > 0 ? wInches + trim * 2 : 0;
      var printH = hInches > 0 ? hInches + trim * 2 : 0;
      var printSqft = (printW * printH) / 144;

      if (wallOut) wallOut.textContent = wallSqft > 0 ? round1(wallSqft) : '—';
      if (printOut) printOut.textContent = printSqft > 0 ? round1(printSqft) : '—';

      rateRows.forEach(function (row) {
        var cents = parseFloat(row.dataset.rateCents);
        var out = row.querySelector('[data-ws-rate-total]');
        if (!out) return;
        if (!printSqft || isNaN(cents)) { out.textContent = '—'; return; }
        out.textContent = money(cents * printSqft);
      });

      /* Carry the size into the custom-request modal. The modal is shared with
         the roll PDPs and knows nothing about murals, so this is published on
         a global it can read rather than by reaching into its markup. */
      window.WSMural = {
        wallInches: { width: wInches, height: hInches },
        printedInches: { width: printW, height: printH },
        wallSqft: round1(wallSqft),
        printedSqft: round1(printSqft),
        summary: wInches && hInches
          ? fmtFtIn(wInches) + ' × ' + fmtFtIn(hInches) +
            ' wall · ' + round1(printSqft) + ' sq ft printed'
          : ''
      };
    }

    function fmtFtIn(inches) {
      var ft = Math.floor(inches / 12);
      var rem = Math.round(inches - ft * 12);
      if (rem === 12) { ft += 1; rem = 0; }
      return rem ? ft + ' ft ' + rem + ' in' : ft + ' ft';
    }

    [wFt, wIn, hFt, hIn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', render);
      el.addEventListener('blur', function () {
        /* Inches roll into feet so nobody is left looking at "7 ft 14 in". */
        if ((el === wIn || el === hIn) && num(el) >= 12) {
          var extra = Math.floor(num(el) / 12);
          var ftEl = el === wIn ? wFt : hFt;
          ftEl.value = num(ftEl) + extra;
          el.value = num(el) - extra * 12;
        }
        if (num(el) < 0) el.value = 0;
        render();
      });
    });

    render();
  });
})();
